import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ListDemand} from 'components/demand';
import title from 'constants/TitlePages.js';

class ListDemandPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.ListDemandPage;
  }

  render() {
    return (
      <MasterLayout>
        <ListDemand/>
      </MasterLayout>
    );
  }
}

export default ListDemandPage;


// WEBPACK FOOTER //
// ./pages/demand/ListDemandPage.jsx